import { controllerModel } from 'shared';

export const roundTripSearchesBottomSheetController = () => {
  const bottomSheet = controllerModel.useBottomSheet();
  const filtersBottomSheetName = 'round-trip-nearest-searches-bottom-sheet';
  return {
    show: () => bottomSheet.show(filtersBottomSheetName),
    hide: () => bottomSheet.hide(filtersBottomSheetName),
    name: filtersBottomSheetName,
  };
};
